
    import '/vercel/path0/docs/demo/bootstrap.md?watch=parent';
    export const toc = [];
export const frontmatter = {"title":"bootstrap","toc":"menu","filename":"docs/demo/bootstrap.md","lastUpdated":1767583902000,"nav":{"title":"Demo","path":"/demo"}};